<template>
  <modal
    v-if="show"
    width="600px"
    :title="t('Manual cost update')"
    @close="checkClose"
    bodyOverflow="auto"
    :read-article-url="`https://docs.bemob.com/${locale}/update-traffic-cost`"
  >
    <template v-if="step === 1">
        <div class="campaign-details">
          <div class="campaign-details__wrap">
            <ui-label class="campaign-name">
              {{ t('Campaign name') }} - {{ name }}
            </ui-label>
            <div class="mt-8 mb-16">
              <v-card-text
                class="text-wrap__warn w100"
              >
                {{ t('Restrictions') }}:
                <ul>
                  <li>
                    {{ t('cost can be updated for the last 32 days max') }};
                  </li>
                  <li>
                    {{ t('cost update time will be 5 min less from the current time') }};
                  </li>
                  <li>
                    {{ t('next cost update should be done not earlier than in 10 min') }};
                  </li>
                  <li>
                    {{ t('cost can be updated 60 times max per each time frame') }}.
                  </li>
                </ul>
              </v-card-text>
            </div>

            <div class="update-cost__period-wrap">
              <ui-period-picker-input
                :label="t('Update Period')"
                :value="{
                  from: form.startTimestamp,
                  to: form.endTimestamp,
                }"
                :start-timestamp-errors="errorsDict['startTimestamp']"
                :end-timestamp-errors="errorsDict['endTimestamp']"
                time-in-title
                :hide-details="2"
                @input="handleUpdatePeriod"
                :showTimezone="false"
              ></ui-period-picker-input>
            </div>

          <div>
            <ui-select
              v-model="form.timezone"
              :placeholder="t('Timezone')"
              :label="t('Timezone')"
              :items="timezoneList"
              item-text="name"
              item-value="zone"
              :return-object="false"
              :hide-details="2"
              :error-messages="errorsDict['timezone']"
            ></ui-select>
          </div>

          <div style="margin-top: 6px">
            <ui-select
              v-model="form.currencyId"
              :placeholder="t('Currency')"
              :label="t('Currency')"
              :items="currencyListOrderedPreferred"
              item-text="name"
              item-value="code"
              :return-object="false"
              :hide-details="2"
              :error-messages="errorsDict['currencyId']"
            ></ui-select>
          </div>

          <div class>
            <ui-input
              v-model="form.cost"
              :label="t('Cost')"
              :placeholder="t('Cost')"
              :bulky="true"
              :prefix="currencies[form.currencyId || '']"
              :has-errors="!!errorsDict['cost']"
              :disabled="!!form.restore"
            ></ui-input>
          </div>

          <div class="checkbox__wrap">
            <ui-checkbox
              :label="t('Restore')"
              :help-tooltip="t('This option allows to restore the cost received from traffic source through dedicated cost token.')"
              v-model="form.restore"
            ></ui-checkbox>
          </div>
        </div>
      </div>
    </template>

    <template #footer>
      <section
        v-if="step === 1"
        class="d-flex justify-end xs12"
        style="display: flex; width: 100%"
      >
        <div class="d-flex align-items-center update-cost__errors">
          <error-aggregator
            v-model="errors"
            v-model:active="errorsControlActive"
          ></error-aggregator>
        </div>

        <div class="d-flex justify-end" style="flex-grow: 0 !important;">
          <ui-button
            :text="t('Cancel')"
            icon="fas fa-times"
            @click="checkClose"
          ></ui-button>

          <ui-button
            :text="t('Save')"
            icon="fas fa-check"
            button-style="accent"
            @click="submit"
          ></ui-button>
          </div>
      </section>
    </template>
  </modal>
</template>

<script setup lang="ts">
import { useCampaignUpdateCost } from './useCampaignUpdateCost';

const emit = defineEmits<{
  close: [];
}>();

const {
  t,
  locale,
  step,
  show,
  name,
  form,
  timezoneList,
  currencyListOrderedPreferred,
  currencies,
  errors,
  errorsControlActive,
  errorsDict,
  checkClose,
  handleUpdatePeriod,
  submit,
} = useCampaignUpdateCost(() => emit('close'));
</script>

<style lang="scss">
.text-wrap__warn {
  background-color: var(--color-pink);
  padding: 16px !important;
  margin-bottom: 6px;
  font-size: 13px;
  line-height: 1.5;
  letter-spacing: normal;

  ul {
    margin: 0;
    padding-left: 24px;
  }
}

.data-picker-head-cost {
  label {
    font-size: 17px !important;
    top: 0 !important;
  }
}

.update-cost__period-wrap {
  .v-menu {
    width: 100%;
  }
  .flex {
    margin-left: 0 !important;
  }
}
</style>

<style lang="scss" scoped>
.cost-label {
  color: var(--color-black);
}

.campaign-name {
  max-width: 100%;
  overflow: hidden;
  word-break: break-word;
}

.update-cost__errors {
  flex: 1 1 auto;
}
</style>
